import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { PricePipeModule } from "src/app/pipes/price/price-pipe.module";

import { PriceCategoryComponent } from "./price-category.component";

@NgModule({
  declarations: [PriceCategoryComponent],
  imports: [CommonModule, IonicModule, PricePipeModule],
  exports: [PriceCategoryComponent],
})
export class PriceCategoryModule {}
